// const BASE_URL = "http://localhost:5000/";
// const BASE_URL = "https://navdalm-001-site5.ktempurl.com/";
const BASE_URL = "https://softisans.com/";
export default BASE_URL;